import { useLocation } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext.tsx'
import { useAppDispatch } from '../../../../../store/hooks.ts'
import { setMobileSidebarOpen } from '../../../../../store/ui/uiSlice.ts'
import BurgerIcon from '../../../../../assets/icons/icon-burger.svg?react'
import { TextNorm } from '../../../../ui/Text'
import css from './MobileTopBar.module.css'

const MobileTopBar = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const { workspace } = useWorkspace()

    const getPageLabel = (): string => {
        if (!workspace) return ''
        const path = location.pathname
        if (path === `/${workspace.workspaceUrlId}`) return 'Plate'
        if (path === `/${workspace.workspaceUrlId}/my-tasks`) return 'My tasks'
        if (path === `/${workspace.workspaceUrlId}/team`) return 'Team'
        if (path.startsWith(`/${workspace.workspaceUrlId}/project`)) return 'Projects'
        if (path === `/${workspace.workspaceUrlId}/all-tasks`) return 'All tasks'
        if (path === `/${workspace.workspaceUrlId}/inbox`) return 'Inbox'
        return ''
    }

    return (
        <div className={css.mobile_menu_button} onClick={() => dispatch(setMobileSidebarOpen(true))}>
            <BurgerIcon />
            <TextNorm>{getPageLabel()}</TextNorm>
        </div>
    )
}

export default MobileTopBar
